import { TabContent, TabHeader } from "@components/views/tabs-view";

import Attributes from "./attributes";
import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Card from "@components/ui-components/card";
import Conversations from "./tabs/conversations";
import Dashboard from "./tabs/dashboard";
import Email from "./tabs/email";
import HealthScore from "./tabs/health-score";
import Meetings from "./tabs/meetings";
import Notes from "./tabs/notes";
import People from "./tabs/people";
import Tasks from "./tabs/tasks";
import Tickets from "./tabs/tickets";
import Timeline from "./tabs/timeline";
import Usage from "./tabs/usage";
import useDetails from "./use-details";
import { useParams } from "react-router-dom";
import { ChildComapnies } from "./tabs/child-companies";

function CompanyDetails () {
    const { active, toggle, details, fetchDetails, handleModal, modalConfig, loading } =
        useDetails();

    const { platformId } = useParams();
    const isParentCompany = details?.attributes?.is_p_comp;
    const TabsList = [
        {
            id     : "dashboard",
            name   : "Company Dashboard",
            content: <Dashboard />,
            omit   : true
        },
        {
            id     : "tasks",
            name   : "Tasks",
            content: <Tasks />
        },
        {
            id     : "notes",
            name   : "Notes",
            content: <Notes />
        },
        {
            id     : "people",
            name   : "People",
            content: <People />
        },
        {
            id     : "gmail",
            name   : "Gmail",
            content: <Email />
        },
        {
            id     : "meetings",
            name   : "Meetings",
            content: <Meetings />
        },
        {
            id     : "tickets",
            name   : "Tickets",
            content: <Tickets attributes={details.attributes || {}} />
        },
        {
            id     : "conversations",
            name   : "Conversations",
            content: <Conversations attributes={details.attributes || {}} />
        },
        {
            id     : "timeline",
            name   : "Timelines",
            content: <Timeline />
        },
        {
            id     : "health-score",
            name   : "Health Score",
            content: <HealthScore />
        },
        {
            id     : "usage",
            name   : "Usage",
            content: <Usage attributes={details.attributes || {}} />
        },
        {
            id     : "child-companies",
            name   : "Child Companies",
            content: <ChildComapnies />,
            omit   : !isParentCompany
        }
    ];

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title: "Companies",
                        to   : `/product/${platformId}/companies`
                    },
                    {
                        title : details.attributes?.company_name || "-",
                        active: true
                    }
                ]}
                bottomChildren={
                    <TabHeader
                        tabs={TabsList}
                        active={active}
                        toggle={toggle}/>
                }/>
            <Card>
                <div className="position-relative companies-container">
                    <div className="scrollable-content">
                        <TabContent active={active} tabs={TabsList} loading={loading} />
                    </div>
                    <Attributes
                        fetchDetails={fetchDetails}
                        handleModal={handleModal}
                        modalConfig={modalConfig}
                        loading={loading}
                        details={details}/>
                </div>
            </Card>
        </>
    );
}

export default CompanyDetails;
